import ClinicApp from './ClinicApp.jsx';

export default function App() {
  return <ClinicApp />;
}
